import { defineMessages } from 'react-intl';
import { TransactionBankOperationCategory, CashFlowCategory } from '@algoan/dashboard/model';

export const messages = defineMessages({
  [CashFlowCategory.DIFFERED_PAYMENT]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.DIFFERED_PAYMENT',
    defaultMessage: 'Differed payment',
    description: 'Cash flow row DIFFERED_PAYMENT',
  },
  [CashFlowCategory.OTHER_EXPENSE]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.OTHER_EXPENSE',
    defaultMessage: 'Other expense',
    description: 'Cash flow row OTHER_EXPENSE',
  },
  [CashFlowCategory.REGULAR_EXPENSE]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.REGULAR_EXPENSE',
    defaultMessage: 'Regular expense',
    description: 'Cash flow row REGULAR_EXPENSE',
  },
  [CashFlowCategory.POWER]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.POWER',
    defaultMessage: 'Power',
    description: 'Cash flow row POWER',
  },
  [CashFlowCategory.TELECOM]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.TELECOM',
    defaultMessage: 'Telecom',
    description: 'Cash flow row TELECOM',
  },
  [CashFlowCategory.SPLIT_PAYMENT]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.SPLIT_PAYMENT',
    defaultMessage: 'Split payment',
    description: 'Cash flow row SPLIT_PAYMENT',
  },
  [CashFlowCategory.RENT]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.RENT',
    defaultMessage: 'Rent',
    description: 'Cash flow row RENT',
  },
  [CashFlowCategory.PRO_TAX]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.PRO_TAX',
    defaultMessage: 'Tax',
    description: 'Cash flow row PRO_TAX',
  },
  [CashFlowCategory.PERSO_TAX]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.PERSO_TAX',
    defaultMessage: 'Tax',
    description: 'Cash flow row PERSO_TAX',
  },
  [CashFlowCategory.CARD_PAYMENT]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.CARD_PAYMENT',
    defaultMessage: 'Card payment',
    description: 'Cash flow row CARD_PAYMENT',
  },
  [CashFlowCategory.ATM]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.ATM',
    defaultMessage: 'ATM',
    description: 'Cash flow row ATM',
  },
  [CashFlowCategory.GAMBLING]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.GAMBLING',
    defaultMessage: 'Gambling',
    description: 'Cash flow row GAMBLING',
  },
  [CashFlowCategory.LOAN]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.LOAN',
    defaultMessage: 'Loan',
    description: 'Cash flow row LOAN',
  },
  [CashFlowCategory.OTHER_INCOME]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.OTHER_INCOME',
    defaultMessage: 'Other income',
    description: 'Cash flow row OTHER_INCOME',
  },
  [CashFlowCategory.REGULAR_INCOME]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.REGULAR_INCOME',
    defaultMessage: 'Regular income',
    description: 'Cash flow row REGULAR_INCOME',
  },
  [CashFlowCategory.RENTAL_INCOME]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.RENTAL_INCOME',
    defaultMessage: 'Rental income',
    description: 'Cash flow row RENTAL_INCOME',
  },
  [CashFlowCategory.GAMBLING_GAIN]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.GAMBLING_GAIN',
    defaultMessage: 'Gambling gain',
    description: 'Cash flow row GAMBLING_GAIN',
  },
  [CashFlowCategory.PRO_TAX_PAYBACK]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.PRO_TAX_PAYBACK',
    defaultMessage: 'Tax payback',
    description: 'Cash flow row PRO_TAX_PAYBACK',
  },
  [CashFlowCategory.PERSO_TAX_PAYBACK]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.PERSO_TAX_PAYBACK',
    defaultMessage: 'Tax payback',
    description: 'Cash flow row PERSO_TAX_PAYBACK',
  },
  [CashFlowCategory.PAYMENT_REJECTION]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.PAYMENT_REJECTION',
    defaultMessage: 'Payment rejection',
    description: 'Cash flow row PAYMENT_REJECTION',
  },
  [CashFlowCategory.LOC_DRAWDOWN]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.LOC_DRAWDOWN',
    defaultMessage: 'Loc drawdown',
    description: 'Cash flow row LOC_DRAWDOWN',
  },
  [CashFlowCategory.HEALTH_ALLOWANCE]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.HEALTH_ALLOWANCE',
    defaultMessage: 'Health allowance',
    description: 'Cash flow row HEALTH_ALLOWANCE',
  },
  [CashFlowCategory.UNEMPLOYMENT_ALLOWANCE]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.UNEMPLOYMENT_ALLOWANCE',
    defaultMessage: 'Unemployment allowance',
    description: 'Cash flow row UNEMPLOYMENT_ALLOWANCE',
  },
  [CashFlowCategory.FAMILY_ALLOWANCE]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.FAMILY_ALLOWANCE',
    defaultMessage: 'Family allowance',
    description: 'Cash flow row FAMILY_ALLOWANCE',
  },
  [CashFlowCategory.RETIREMENT_PENSION]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.RETIREMENT_PENSION',
    defaultMessage: 'Retirement pension',
    description: 'Cash flow row RETIREMENT_PENSION',
  },
  [CashFlowCategory.WAGE]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.WAGE',
    defaultMessage: 'Wage',
    description: 'Cash flow row WAGE',
  },
  [CashFlowCategory.BANK_SERVICE_FEES]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.BANK_SERVICE_FEES',
    defaultMessage: 'Bank service fees',
    description: 'Cash flow row BANK_SERVICE_FEES',
  },
  [CashFlowCategory.BANK_INCIDENT_FEES]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.BANK_INCIDENT_FEES',
    defaultMessage: 'Bank incident fees',
    description: 'Cash flow row BANK_INCIDENT_FEES',
  },
  [CashFlowCategory.BANK_INCIDENT_REFUND]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.BANK_INCIDENT_REFUND',
    defaultMessage: 'Bank incident refund',
    description: 'Cash flow row BANK_INCIDENT_REFUND',
  },
  [CashFlowCategory.OVERDRAFT_FEES]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.OVERDRAFT_FEES',
    defaultMessage: 'Overdraft fees',
    description: 'Cash flow row OVERDRAFT_FEES',
  },
  [CashFlowCategory.INSURANCE]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.INSURANCE',
    defaultMessage: 'Insurance',
    description: 'Cash flow row INSURANCE',
  },
  [CashFlowCategory.INSURANCE_REFUND]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.INSURANCE_REFUND',
    defaultMessage: 'Insurance refund',
    description: 'Cash flow row INSURANCE_REFUND',
  },
  [CashFlowCategory.INTERNAL_TRANSFER]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.INTERNAL_TRANSFER',
    defaultMessage: 'Internal transfer',
    description: 'Cash flow row INTERNAL_TRANSFER',
  },
  [CashFlowCategory.CHECK]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.CHECK',
    defaultMessage: 'Check',
    description: 'Cash flow row CHECK',
  },
  [CashFlowCategory.CHECK_DEPOSIT]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.CHECK_DEPOSIT',
    defaultMessage: 'Check deposit',
    description: 'Cash flow row CHECK_DEPOSIT',
  },
  [CashFlowCategory.CHECK_REJECTION]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.CHECK_REJECTION',
    defaultMessage: 'Check rejection',
    description: 'Cash flow row CHECK_REJECTION',
  },
  [CashFlowCategory.ATM_DEPOSIT]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.ATM_DEPOSIT',
    defaultMessage: 'Atm deposit',
    description: 'Cash flow row ATM_DEPOSIT',
  },
  [CashFlowCategory.CARD_REFUND]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.CARD_REFUND',
    defaultMessage: 'Card refund',
    description: 'Cash flow row CARD_REFUND',
  },
  [CashFlowCategory.MULTIMEDIA]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.MULTIMEDIA',
    defaultMessage: 'Multimedia',
    description: 'Cash flow row MULTIMEDIA',
  },
  [CashFlowCategory.TOBACCO_SHOP]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.TOBACCO_SHOP',
    defaultMessage: 'Tobacco shop',
    description: 'Cash flow row TOBACCO_SHOP',
  },
  [CashFlowCategory.STATE_SUBSIDY]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.STATE_SUBSIDY',
    defaultMessage: 'State subsidy',
    description: 'Cash flow row STATE_SUBSIDY',
  },
  [CashFlowCategory.ANTICIPATED_LOAN_REFUND]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.ANTICIPATED_LOAN_REFUND',
    defaultMessage: 'Anticipated loan refund',
    description: 'Cash flow row ANTICIPATED_LOAN_REFUND',
  },
  [CashFlowCategory.CHECK_REJECTION_FEES]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.CHECK_REJECTION_FEES',
    defaultMessage: 'Check rejection fees',
    description: 'Cash flow row CHECK_REJECTION_FEES',
  },
  [CashFlowCategory.PAYMENT_REJECTION_FEES]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.PAYMENT_REJECTION_FEES',
    defaultMessage: 'Payment rejection fees',
    description: 'Cash flow row PAYMENT_REJECTION_FEES',
  },
  [CashFlowCategory.INTERVENTION_FEES]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.INTERVENTION_FEES',
    defaultMessage: 'Intervention fees',
    description: 'Cash flow row INTERVENTION_FEES',
  },
  [CashFlowCategory.EXPENSE_REPORT_REFUND]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.EXPENSE_REPORT_REFUND',
    defaultMessage: 'Expense report refund',
    description: 'Cash flow row EXPENSE_REPORT_REFUND',
  },
  [CashFlowCategory.LEASING]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.LEASING',
    defaultMessage: 'Leasing',
    description: 'Cash flow row LEASING',
  },
  [CashFlowCategory.BANK_BENEFIT]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.BANK_BENEFIT',
    defaultMessage: 'Bank benefit',
    description: 'Cash flow row BANK_BENEFIT',
  },
  [TransactionBankOperationCategory.REJECTION_LOAN_REPAYMENT]: {
    id: 'widgets.regular_cash_flows_analysis.cash_flow.REJECTION_LOAN_REPAYMENT',
    defaultMessage: 'Loan repayment rejection',
    description: 'Cash flow row REJECTION_LOAN_REPAYMENT',
  },
  categoryResources: {
    id: 'widgets.regular_cash_flows_analysis.category.resources',
    defaultMessage: 'Resources',
    description: 'Category resources title',
  },
  categoryIncomes: {
    id: 'widgets.regular_cash_flows_analysis.category.incomes',
    defaultMessage: 'Incomes',
    description: 'Category incomes title',
  },
  categoryFixedCharges: {
    id: 'widgets.regular_cash_flows_analysis.category.fixedCharges',
    defaultMessage: 'Fixed charges',
    description: 'Category fixed charges title',
  },
  categoryExpenses: {
    id: 'widgets.regular_cash_flows_analysis.category.expenses',
    defaultMessage: 'Expenses',
    description: 'Category expenses title',
  },
  categoryLoans: {
    id: 'widgets.regular_cash_flows_analysis.category.loans',
    defaultMessage: 'Loans',
    description: 'Category loans title',
  },
  firstDayOfMonth: {
    id: 'widgets.regular_cash_flows_analysis.timeline.first_day_of_month',
    defaultMessage: '1st day of month',
    description: 'First tick on the timeline',
  },
  fifteenthDayOfMonth: {
    id: 'widgets.regular_cash_flows_analysis.timeline.fifteenth_day_of_month',
    defaultMessage: '15th day of month',
    description: 'Second tick on the timeline',
  },
  columnHeader: {
    id: 'widgets.regular_cash_flows_analysis.column_header',
    defaultMessage: 'Contribution reste à vivre',
    description: 'Header of the first column',
  },
});
